import { fetchInitials } from "queries"
import AppsPage from "../../views/apps"
import { GetServerSideProps } from "next"
import useQueryPlus from "utils/useQueryPlus"

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  return {
    props: {
      query,
    },
  }
}

const Apps = ({ query }: any) => {
  useQueryPlus({
    queryFn: fetchInitials,
    queryKey: ["initialApps"],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    cacheTime: Infinity,
    staleTime: Infinity,
  })
  return <AppsPage query={query} />
}
export default Apps
